export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const QA_LOGIN = BASE_URL + '/login';
export const USER_LOOKUP = BASE_URL + '/users/me';
export const FORGOT_PASSWORD = BASE_URL + '/forgot-password';
export const LOGOUT = BASE_URL + '/logout';

export const AUDIT_UPLOADS = BASE_URL + '/manager/charts';
export const RECENT_AUDITS = BASE_URL + '/auditsheet/audithours/recent_audits';

//AUDIT SHEET
export const AUDIT_SHEET = BASE_URL + '/auditsheet/:uploadId/';
export const MONITOR_HOUR = BASE_URL + '/auditsheet/audithours/:uploadId/';
export const AUDIT_UPLOAD = BASE_URL + '/manager/charts/:uploadId/';
export const AUDIT_SHEET_INDUSTRY = BASE_URL + '/auditsheet/industry/';
export const AUDIT_SHEET_ICD_CODES = BASE_URL + '/auditsheet/icd-code/';
export const AUDIT_SHEET_MODIFIER = BASE_URL + '/auditsheet/modifier/';
export const AUDIT_REPORT = BASE_URL + '/auditsheet/audit-report/'
export const UPDATE_ACTIVITY =
  BASE_URL + '/auditsheet/comment/updation_activity/';
export const AUDITSHEET_USER = BASE_URL + '/auditsheet/cqusers/';
export const GET_COMMENT = BASE_URL + '/auditsheet/comment/:uploadId';
export const GET_BATCH_COMMENT = BASE_URL + '/auditsheet/comment/:batchId/client_comment';
export const GET_ALL_USER_API = BASE_URL + '/users';
export const GET_COMMENT_FLAG =
  BASE_URL + '/auditsheet/comment/:uploadId/cell_flag/';
export const POST_COMMENT = BASE_URL + '/auditsheet/comment/';
export const MANAGE_COMMENT = BASE_URL + '/auditsheet/comment/:commentId/';
export const SEND_TO_AUDITOR = BASE_URL + '/auditsheet/comment/:uploadId/send_to_auditor/';
export const AVAILABLE_AUDITORS = BASE_URL + '/manager/specialties/reviewers/';
export const REBUTTAL_SUBMIT_VALIDATION = BASE_URL + '/auditsheet/comment/:uploadId/rebuttal_submit_validation/';
export const AUDIT_SHEET_PROVIDER_DROPDOWN =
  BASE_URL + '/client/dashboard/:chartId/provider_dropdown/';
export const AUDIT_SHEET_RESPONSE_ISSUES_DROPDOWN =
  BASE_URL + '/auditsheet/response_options/';

// notifications
export const GET_NOTIFICATIONS = BASE_URL + '/notifications/';
export const CHANGE_NOTIFICATION_STATUS =
  BASE_URL + '/notifications/:notificationId/';
export const MARK_ALL_READ_NOTIFICATIONS = BASE_URL + '/notifications/mark_all_read/';

export const GET_FAQ = BASE_URL + '/faq';

// version 2 get charts
export const MY_CHARTS = BASE_URL + '/client/dashboard/';
// export const GET_CLIENT_SPECIALTIES = BASE_URL + '/client/dashboard/get-specialties';
// export const CHART_UPDATE_V2 = BASE_URL + '/manager/charts/update-v2/';
// export const REVIEWERS = BASE_URL + '/manager/specialties/reviewers'

// batch audit sheet
export const BATCH_AUDIT_SHEET =
  BASE_URL + '/client/dashboard/:batchId/auditsheet/';

export const GET_FILE_BY_BATCH =
  BASE_URL + '/client/dashboard/:batchId/batchresult';

export const GET_CLIENT_COMMENT_FLAG =
  BASE_URL + '/auditsheet/comment/:batchId/client_cell_flag/';
export const GET_CLIENT_COMMENT =
  BASE_URL + '/auditsheet/comment/:batchId/client_comment';
export const GET_BATCH_ALL_COMMENTS =
  BASE_URL + '/auditsheet/comment/:batchId/batch_all_comments';
